module.exports = "/_next/static/images/MakeItAContinuousConversation@2x-c3d13844d060a865c00522aff06b005d.png";